import './../../partials/project/common/modal-journal-content/modal-journal-content';
import './../../partials/project/common/journal-dropdown/journal-dropdown';